import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchSupplierDetail(id) {
  const { data: raw } = await request.get(`/srm/supplier/${id}`);
  return parseVer4DetailResponse(raw);
}
